const formControlLabelCalendar = {
  checkActions: 'Acciones',
  checkServices: 'Servicios Realizados',
  checkFutureServices: 'Servicios Futuros',
  checkMaintenances: 'Mantenimientos',
  checkServicesReplicated: 'Servicios A Realizar / Vencidos',
};

export default formControlLabelCalendar;
